// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_96-0";
export var headerCellHover = "_96-1";
export var readCellContainer = "_96-2";
export var readCellSlot = "_96-3";
export var rowHoverCheckbox = "_96-4";
export var rowUnreadIndicator = "_96-5";
export var searchHighlight = "_96-8";
export var summaryCellHoverWrapper = "_96-9";
export var supportTicketRow = "_96-6";
export var unreadIndicator = "_96-7";